import { render, staticRenderFns } from "./share-coupon-ad.vue?vue&type=template&id=f7f3979e&"
import script from "./share-coupon-ad.vue?vue&type=script&lang=ts&"
export * from "./share-coupon-ad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports